import login from './js/_alpine-login.js';
new login('Alpine_LoginForm');

import register from './js/_alpine-register.js';
new register('Alpine_RegisterForm');